module.exports = __webpack_public_path__ + "media/images/tennis-image-a8fd2393830d6c85a9e36cc36da48b1d.jpg";